import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaLeis from '../../components/leis/listar';


function LeisScreen () {
    return (
        <Fragment>
            <Head titulo="Legislação do Município de Macuco"/>
            <Header />
            <Container>
                <ListaLeis />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LeisScreen;